import { DateCell } from './cells/DateCell';
import { DateTimeCell } from './cells/DateTimeCell';
import { NumberCell } from './cells/NumberCell';
import { TextCell } from './cells/TextCell';
import { SelectCell } from './cells/SelectCell';
import { BOOLEAN_OPTIONS, SCHEMA_TYPES, SCHEMA_FORMATS } from './constants';
import commonStore from '../../../../../store/common';

export const renderCell = ({
  columnSchema,
  value,
  onCellChange,
  error = null,
  cellRefs = null,
  cellKey = null,
  onCellKeyDown = null,
  fundId = null,
  fundName = null,
  tableName = null,
  fieldName = null,
  fieldOrder = null,
  isFromStaticTemplate = false,
  isStaticTemplateModalOpen = false,
  ...props
}) => {
  const { isViewer } = commonStore;
  const commonProps = {
    error: isViewer ? null : error,
    cellRefs,
    cellKey,
    onCellKeyDown,
    fundId,
    fundName,
    tableName,
    fieldName,
    fieldOrder,
    isFromStaticTemplate: isStaticTemplateModalOpen ? false : isFromStaticTemplate,
    ...props
  };

  if (columnSchema?.type?.includes(SCHEMA_TYPES.ARRAY)) {
    return (
      <SelectCell
        value={value}
        options={columnSchema.rules?.array?.enum || []}
        onChange={onCellChange}
        {...commonProps}
      />
    );
  }

  if (
    columnSchema?.type.includes(SCHEMA_TYPES.STRING) &&
    columnSchema.format === SCHEMA_FORMATS.DATE
  ) {
    return <DateCell value={value} onChange={onCellChange} {...commonProps} />;
  }

  if (
    columnSchema?.type.includes(SCHEMA_TYPES.STRING) &&
    columnSchema.format === SCHEMA_FORMATS.DATE_TIME
  ) {
    return <DateTimeCell value={value} onChange={onCellChange} {...commonProps} />;
  }

  if (columnSchema?.type.includes(SCHEMA_TYPES.DATE_TIME)) {
    return <DateTimeCell value={value} onChange={onCellChange} {...commonProps} />;
  }

  if (columnSchema?.type.includes(SCHEMA_TYPES.DATE)) {
    return <DateCell value={value} onChange={onCellChange} {...commonProps} />;
  }

  if (columnSchema?.type.includes(SCHEMA_TYPES.STRING)) {
    return <TextCell value={value} onChange={onCellChange} {...commonProps} />;
  }

  if (
    columnSchema?.type.includes(SCHEMA_TYPES.NUMBER) ||
    columnSchema?.type.includes(SCHEMA_TYPES.INTEGER)
  ) {
    return <NumberCell value={value} onChange={onCellChange} {...commonProps} />;
  }

  if (columnSchema?.type.includes(SCHEMA_TYPES.BOOLEAN)) {
    return (
      <SelectCell
        value={typeof value === 'boolean' ? value.toString() : null}
        options={BOOLEAN_OPTIONS}
        onChange={val => onCellChange(val === 'true')}
        {...commonProps}
      />
    );
  }

  return null;
};
